import React from "react";
import "./BannerNosotros.css";

export default function BannerNosotros() {
  return (
    <section className="banner-nosotros">
      <div className="banner-color-nosotros">
        <div className="banner-content-nosotros">
          <div className="banner-text-nosotros">
            <h1 className="banner-title-nosotros">Sobre Nosotros</h1>
          </div>
        </div>
      </div>
    </section>
  );
}
